import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {
  constructor(
    private authStatusService: AuthStatusService,
    private commanUsesService: CommanUsesService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const guestView = await this.authStatusService.isAuthenticated();
      if (guestView) {
        const userInfo = JSON.parse(sessionStorage.getItem('currentUser'));
        const isSuperAdmin = userInfo?.group?.name?.toLowerCase() === 'admin' && userInfo?.isSuperAdmin;

        if (isSuperAdmin) {
          return true;
        } else {
          this.router.navigate(['/404']);
          return false;
        }
      } else {
        this.router.navigate(['/push/login']);
        return false;
      }
    } catch (error) {
      this.commanUsesService.showSnackBar(`ERROR_${error?.message || 'UNKNOWN_ERROR'}`);
      this.router.navigate(['/push/login']);
      return false;
    }
  }
}
